import { useEffect, memo, useState, Fragment } from "react";
import { useHistory } from "react-router-dom";

import { getTransactionResult } from "../../Actions/Actions";
import { priceDigitSeperator } from "../../Utils/Helpers";
import errorSvg from "../../Assets/Images/error.svg";
import tickSvg from "../../Assets/Images/tick.svg";
import Business from "../../Components/Business";
import Loading from "../../Components/Loading";
import Row from "../../Components/Row";
import "./styles.css";
import { getSoftPosTransactionResult } from "../../Actions/DaapAppSoftPosActions/SoftPosActions";
import Colors from "../../Constants/Colors";

const Screen = (props) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({});
  const [timer, setTimer] = useState(3);
  const params = props.location.state;
  let interval = null;

  useEffect(() => {
    if (params.hasOwnProperty("transactionId")) {
      // اگر از صفحه پرداخت برگشته بود این سرویس اجرا می شود
      setLoading(true);
      if (params.hasOwnProperty("isSoftPos")) {
        getSoftPosTransactionResult(params.transactionId)
          .then((res) => {
            setDetail(res);
          })
          .finally((_) => {
            setLoading(false);
          });
      } else {
        getTransactionResult(params.transactionId)
          .then((res) => {
            setDetail(res);
          })
          .finally((_) => {
            setLoading(false);
          });
      }
    } else {
      // اگر از صفحه اول برگشت مقدار پارامتر را با state تغییرمیکند
      setDetail(params);
    }
    timerRedirectPage();
    return () => clearInterval(interval);
  }, []);

  const timerRedirectPage = () => {
    interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) clearInterval(interval);
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (timer === 0) {
      if (detail.redirect === "payment_gateway_callback") {
        let link = detail.gateway_callback;
        window.open(link, "_self");
      }
    }
  }, [timer]);

  return (
    <div className="sign-in">
      {!loading ? (
        <Fragment>
          {!params?.isSoftPos ? (
            <p className="text-center">
              شما <span className="text-info">{timer}</span> ثانیه دیگر به سایت
              پذیرنده هدایت می شوید
            </p>
          ) : null}

          <img
            className="modal-result-status-img"
            src={detail?.status === "success" ? tickSvg : errorSvg}
          />
          <p className="text-center mt-3">
            {detail?.status === "success"
              ? "تراکنش با موفقیت انجام شد"
              : "پرداخت با خطا مواجه شد"}
          </p>
          <Business isResult={true} data={detail} />
          <Row
            title="پرداخت از درگاه بانکی:"
            value={priceDigitSeperator(detail?.pay_with_gateway) || "0"}
          />
          <Row
            title="پرداخت از کیف پول داپ اَپ:"
            value={priceDigitSeperator(detail?.pay_with_wallet) || "0"}
          />
          <div className="line"></div>
          <Row
            title="مبلغ کل فاکتور:"
            value={priceDigitSeperator(detail?.total_amount) || "0"}
          />
          <div className="line"></div>
          <Row title="کد رهگیری:" value={detail?.tracking_code} span={true} />

          {params?.isSoftPos ? (
            <div className="my-4 w-100 d-flex justify-content-center">
              <button
                className="btn-success w-50 m-auto  py-2 text-white rounded text-center border-0"
                style={{ background: Colors.green }}
                onClick={() => window.open(detail.gateway_callback, "_self")}
              >
                بازگشت به صفحه اصلی
              </button>
            </div>
          ) : null}
        </Fragment>
      ) : (
        <Loading />
      )}
    </div>
  );
};
export default memo(Screen);
